(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/play/assets/javascripts/views/single-rows-container.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/play/assets/javascripts/views/single-rows-container.js');

'use strict';

svs.eurojackpot.components.play.views.SingleRowsContainer = Marionette.View.extend({
  className: 'numbergames-play-content grid-row padding-xs-h-1 padding-xs-bottom-2 padding-sm-h-1 padding-md-bottom-0 padding-md-h-2',
  regions: {
    boardContainerRegion: '#boardContainerRegion',
    rowsRegion: '#rowsRegion'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
    channel: svs.numbergames.game.huxfluxRadio
  }],
  template(data) {
    return svs.eurojackpot.components.play.templates.single_rows_container(data);
  },
  onRender() {
    let boardView;
    if (!svs.core.config.data.svsconfig.isSelfService) {
      boardView = svs.eurojackpot.components.play.views.WheelRow;
    }
    this.showChildView('boardContainerRegion', new svs.numbergames.game.views.BoardContainer({
      model: this.model,
      boardView
    }));
    this.showChildView('rowsRegion', new svs.numbergames.game.views.SingleRowsContainer({
      model: this.model,
      className: 'numbergames-single-rows-container numbergames-single-rows-container-eurojackpot',
      ballRowSize: svs.core.detect.breakpoint.greaterThan('xs') ? 300 : 200
    }));
  }
});

 })(window);